import * as Sentry from "@sentry/vue";

export function setupSentry(Vue) {
  process.env.VUE_APP_LOGIN_ENV === 'prod' && Sentry.init({
    Vue,
    dsn: "https://d68d95cd20ba1dd6085eac80f0b7bd1f@o212519.ingest.us.sentry.io/4507411495124992",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/.*/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
